import React, { useEffect } from 'react';
import { ArrowRight, Cog, GitBranch, Code, Server, BarChart } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useLocation } from 'react-router-dom';
import hero1 from '../../assets/devopsauto.png'
const DevOpsAutomationServices = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
             <Header />
    <div className="bg-gradient-to-b from-black to-gray-800 min-h-screen text-white">
      {/* Header/Nav */}

      {/* Hero Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
              <div className="p-4 inline-block bg-blue-500/20 rounded-xl mb-4">
                <Cog className="w-12 h-12 text-blue-500" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
                DevOps <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">Automation</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8">
                Increase DevOps efficiency and reduce costs
              </p>
              <p className="text-gray-300 mb-8">
                Our DevOps automation services streamline your development pipeline, removing manual processes and reducing human error. We implement CI/CD pipelines, infrastructure as code, and automated testing to accelerate your delivery cycles while maintaining quality and stability.
              </p>
              <Link to='/contact'> 
              <button className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors flex items-center">
                Get Started <ArrowRight className="ml-2 w-5 h-5" /> 
              </button>
              </Link>
            </div>
            <div className="md:w-1/2">
              <div className="p-6">
                <img src={hero1} alt="DevOps Automation" className="rounded-lg w-full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-black50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Key Benefits</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Faster Deployment Cycles</h3>
              <p className="text-gray-300">Automate your pipeline to reduce time between development and production, enabling faster feature delivery and bug fixes.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Reduced Operational Costs</h3>
              <p className="text-gray-300">Minimize infrastructure costs, eliminate manual work, and optimize resource utilization with automated scaling and management.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Improved Code Quality</h3>
              <p className="text-gray-300">Implement automated testing and code analysis to catch issues early and ensure consistent code quality standards.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Enhanced Team Collaboration</h3>
              <p className="text-gray-300">Standardize processes and workflows to improve communication and collaboration between development and operations teams.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Our DevOps Automation Services</h2>
          <div className="space-y-8">
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <GitBranch className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">CI/CD Pipeline Implementation</h3>
                  <p className="text-gray-300 mb-4">
                    We build and optimize continuous integration and continuous deployment pipelines that automate your software delivery process from code commit to production deployment.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Automated build and test processes</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Seamless integration with version control systems</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Deployment automation for consistent releases</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <Code className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Infrastructure as Code</h3>
                  <p className="text-gray-300 mb-4">
                    Define and manage your infrastructure using code, enabling consistent, repeatable, and version-controlled infrastructure provisioning and management.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Terraform, CloudFormation, and ARM templates</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Configuration management with Ansible, Chef, or Puppet</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Immutable infrastructure patterns</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <Server className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Containerization & Orchestration</h3>
                  <p className="text-gray-300 mb-4">
                    Modernize your applications with containerization and implement orchestration solutions for efficient container management and scaling.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Docker containerization</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Kubernetes orchestration</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Service mesh implementation</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
              <div className="flex flex-col md:flex-row">
                <div className="mb-4 md:mb-0 md:mr-6">
                  <div className="p-3 bg-blue-500/20 rounded-lg inline-block">
                    <BarChart className="w-8 h-8 text-blue-500" />
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Monitoring & Alerting Automation</h3>
                  <p className="text-gray-300 mb-4">
                    Implement comprehensive monitoring and alerting systems that provide real-time visibility into your infrastructure and applications.
                  </p>
                  <ul className="space-y-2 mb-4">
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Automated metric collection and visualization</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Intelligent alerting and notification systems</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-blue-500 mr-2">•</span>
                      <span>Log aggregation and analysis</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 px-4 bg-gray-900/50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Our Implementation Process</h2>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 ml-0 md:-ml-1 top-0 h-full w-0.5 bg-blue-500/30"></div>
            
            <div className="space-y-16">
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">1. Assessment & Discovery</h3>
                    <p className="text-gray-300">We analyze your current development and operations processes to identify improvement opportunities and automation candidates.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  1
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-3 md:w-1/2 pl-0 md:pl-8 pb-8 md:pb-0 flex justify-start">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">2. Strategy & Planning</h3>
                    <p className="text-gray-300">We develop a tailored automation strategy and roadmap aligned with your business goals and technical requirements.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  2
                </div>
                <div className="order-3 md:order-1 md:w-1/2 pr-8 md:pr-8 flex justify-end invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">3. Implementation & Integration</h3>
                    <p className="text-gray-300">We implement the automation solutions and integrate them with your existing tools and workflows.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  3
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-3 md:w-1/2 pl-0 md:pl-8 pb-8 md:pb-0 flex justify-start">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">4. Testing & Validation</h3>
                    <p className="text-gray-300">We thoroughly test the automated processes to ensure they meet requirements and function as expected.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  4
                </div>
                <div className="order-3 md:order-1 md:w-1/2 pr-8 md:pr-8 flex justify-end invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
              
              <div className="relative flex flex-col md:flex-row items-center">
                <div className="order-1 md:order-1 md:w-1/2 pr-0 md:pr-8 pb-8 md:pb-0 flex justify-start md:justify-end">
                  <div className="bg-gray-800 p-6 rounded-xl border border-gray-700 shadow-lg max-w-md">
                    <h3 className="text-xl font-bold mb-2">5. Training & Knowledge Transfer</h3>
                    <p className="text-gray-300">We provide comprehensive training to ensure your team can effectively use and maintain the automation systems.</p>
                  </div>
                </div>
                <div className="order-2 md:order-2 z-10 flex items-center justify-center w-10 h-10 bg-blue-600 text-white rounded-full font-bold absolute left-0 md:left-1/2 ml-0 md:-ml-5">
                  5
                </div>
                <div className="order-3 md:order-3 md:w-1/2 pl-8 md:pl-8 flex justify-start invisible md:visible">
                  {/* Placeholder for alignment */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gray-900/50 py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-4">Ready to migrate your cloud?</h2>
              <p className="text-blue-100 max-w-2xl mx-auto">
                Let our experts help you migrate your cloud.
              </p>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
              <Link to='/contact'>
              <button className="w-full md:w-auto bg-white text-blue-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition-colors">
                Schedule a Consultation
              </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
     </div>
     <Footer />
     </div>
  )
}
export {DevOpsAutomationServices};